import { Table } from "semantic-ui-react";
import { type ColumnOption } from "../../../../interfaces/columnOptions";
import { HandleOnSelectionChanged, type SelectionChangedArgs } from "interfaces/onSelectionChanged";

/**
 * Builds table body cells from columns configuration
 */
export const buildTableBody = <T extends object>(item: T, columns: ColumnOption<T>[]) => {
  return columns.map((column) => (
    <Table.Cell className={"table-body-cell"} width={column.width} key={column.name}>
      {column.render(item)}
    </Table.Cell>
  ));
};

/**
 * Creates a selection change handler with add/remove callbacks
 */
export const createSelectionChangeHandler = <T extends object>(
  setSelectedItems: React.Dispatch<React.SetStateAction<T[]>>,
) => {
  return (data: SelectionChangedArgs<T>) => {
    const onAdded = (item: T) => {
      setSelectedItems((prev) => [...prev, item]);
    };

    const onRemoved = (item: T) => {
      setSelectedItems((prev) =>
        "id" in item && typeof item.id === "number"
          ? prev.filter((i) => !("id" in i) || i.id !== item.id)
          : prev.filter((i) => i !== item),
      );
    };

    HandleOnSelectionChanged(data, onAdded, onRemoved);
  };
};
